/**
 * @file lawConfig.js
 * @author sunhemeng<sunhemeng@baidu.com>
 * @desc 法律
 */
import lawinfo from './pages/law-info';
import lawTpInfo from './pages/law-tp-info';
import lawMessageInfo from './pages/law-message-info';
import lawclues from './pages/law-clues';
import bjhEdit from './pages/bjh-edit';
import contact from './pages/law-contact';
import bjhRegister from './pages/bjh-register';
import material from './pages/material';
import vipSet from './pages/vip-set';
import schedulGuide from './pages/schedul-guide';
import firmIndex from './pages/firm-index';
import consultSetting from './pages/law-consult';
import lawservice from './pages/law-service';
import bjhContent from './pages/bjh-content';
import profitCenter from './pages/profit-center';
import lawquestion from './pages/law-question';
import offlineQa from './pages/offline-qa';
import potentialCustomerList from './pages/potential-customer-list';
import customerList from './pages/customer-list';
import memberCodeManage from './pages/member-code-manage';
import lawChargeList from './pages/law-charge-list';
import firmintro from './pages/firm-intro';
import memberManage from './pages/member-manage';
import lawFirmAuthentication from './pages/law-firm-authentication';
import goodsPurchase from './pages/goods-purchase';
import clueOrderManage from './pages/clue-order-manage';
import ruleTool from './pages/rule-tool';
import caseTool from './pages/case-tool';
import customerSea from './pages/customer-sea';
import vipBenefitTool from './pages/vip-benefit-tool';
import dataCenter from './pages/data-center';
import consult from './pages/consult';
import caseManage from './pages/case-manage';
import courseCenter from './pages/course-center';
// import qaManage from './pages/qa-manage';
import personalInfo from './pages/personal-info';
import AIContract from './pages/ai-contract';
import clueBillManage from './pages/clue-bill-manage';
import insuranceTool from './pages/lawsuit-helper';
import agentMemberManage from './pages/agent-member-manage';
import contentMarketing from './pages/content-marketing';
import clientChanceList from './pages/client-chance-list';
import teamLawyer from './pages/team-lawyer';
import firmCaseManage from './pages/firm-case-manage';
import firmHome from './pages/firm-home';
import roleSet from './pages/role-set';
import repositoryManage from './pages/repository-manage';
import hotQuestion from './pages/hot-question';
import performanceDashboard from './pages/performance-dashboard';
import myBk from './pages/my-bk';
import businessCenter from './pages/business-center';
import platformLawyer from './pages/platform-lawyer';
import platformConsult1v1 from './pages/platform-consult';
import aiLiveStream from './pages/ai-live-stream';
import lawcodex from './pages/lawcodex';

export default {
    ruleTool,
    caseTool,
    lawinfo,
    lawTpInfo,
    lawMessageInfo,
    bjhRegister,
    bjhEdit,
    contact,
    vipSet,
    schedulGuide,
    firmIndex,
    material,
    consultSetting,
    bjhContent,
    lawservice,
    profitCenter,
    lawquestion,
    offlineQa,
    potentialCustomerList,
    customerList,
    lawclues,
    memberCodeManage,
    lawChargeList,
    firmintro,
    memberManage,
    lawFirmAuthentication,
    goodsPurchase,
    clueOrderManage,
    consult,
    caseManage,
    customerSea,
    vipBenefitTool,
    dataCenter,
    courseCenter,
    // qaManage,
    personalInfo,
    AIContract,
    clueBillManage,
    insuranceTool,
    agentMemberManage,
    contentMarketing,
    clientChanceList,
    teamLawyer,
    firmCaseManage,
    firmHome,
    roleSet,
    repositoryManage,
    hotQuestion,
    performanceDashboard,
    myBk,
    businessCenter,
    platformLawyer,
    platformConsult1v1,
    aiLiveStream,
    lawcodex
};
